import React, { useState } from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import Filters from './Filters'
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { buildDashboardReportListing } from 'src/mtska-frontend-modules/utils/dashboardSliderReports';
import { Button } from "src/mtska-frontend-app-component";
import { useSettingContextInComponent, useSyncDashboardFullscreenClass } from "src/mtska-frontend-app-scaffolding";

const Container = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    useSyncDashboardFullscreenClass();
    const [reportVisible, setReportVisible] = useState(false);
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const showFilters = true;
    const showKPI = true;

    const report = buildDashboardReportListing(t, dataProviderName, filterModel);

    return (
        <Box className="mtska-dashboard-container" sx={{ position: "relative" }}>
            {(showKPI || showFilters) &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Listing status')}</h2>
                </Box>
            }

            {showFilters &&
                <Filters dataProviderName={dataProviderName} filters={filterModel} />
            }

            <Box className="dashboard-report-visibility-wrapper">
                <Button className="dashboard-report-visibility-toggler" onClick={() => setReportVisible(!reportVisible)} variant={'outlined'}>{reportVisible ? t('Hide report') : t('Show report')}</Button>
            </Box>

            {
                reportVisible && <ComponentSlider report={report} />
            }
            <Box className="mtska-fullscreen-toggle">
                <Button
                    variant="soft"
                    size="sm"
                    icon="faExpand"
                    onClick={() => {
                        const parent = document.querySelector('.mtska-dashboard-container');
                        if (!parent) return;
                        if (document.fullscreenElement || document.webkitFullscreenElement) {
                            parent.classList.remove('mtska-fullscreen');
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen();
                            }
                        } else {
                            if (parent.requestFullscreen) {
                                parent.requestFullscreen()
                                    .then(() => parent.classList.add('mtska-fullscreen'))
                                    .catch(() => parent.classList.remove('mtska-fullscreen'));
                            } else if (parent.webkitRequestFullscreen) {
                                parent.webkitRequestFullscreen();
                                parent.classList.add('mtska-fullscreen');
                            }
                        }
                    }}
                    aria-label={t('Fullscreen')}
                />
            </Box>
        </Box>
    )
}

export default Container;